import { IPropertyVerification } from 'data/entities/property/propertyVerification';
import { IConfiguredHttp } from './http';

export enum PropertyVerificationStatus {
	VERIFIED = 'VERIFIED',
	UNVERIFIED = 'UNVERIFIED',
	NO_DECISION = 'NO_DECISION',
	REJECTED = 'REJECTED',
	PENDING = 'PENDING'
}

export interface IPropertyVerificationApi {
	updateVerificationStatus: (propertyId: number, status: PropertyVerificationStatus) => Promise<IPropertyVerification>;
}

const propertyVerificationApiFactory = (http: IConfiguredHttp, prefix = 'properties'): IPropertyVerificationApi => ({
	updateVerificationStatus(propertyId, status) {
		return http.put(`${prefix}/${propertyId}/verification`, { verification_status: status });
	}
});

export default propertyVerificationApiFactory;
